import React, { Component } from 'react';
import { Switch } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { formDataSchema } from '../../../../schema/user-doctor-map';
import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import networkList from '../../../../constants/networkList';

const {homepage} = networkList;
class User_Doctor_Map extends Component {
    onChange(checked) {
        console.log(`switch to ${checked}`);
    }
    render() {
        return (
            <div className="row  user-map">
                <div className="col-3 slideInUp">
                    <div className="card mt-5 mb-5 ml-5 mr-2 card-table">
                        <div className="card-header bg8">
                            <div className="pt-1">
                                User List
                            </div>
                        </div>
                        <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0 h-25">
                                <tbody>
                                    <tr>
                                        <td >Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td className="active">Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                    <tr>
                                        <td>Abhishek Chowdhury</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-9">
                    <div className="card mt-5 mb-5 mr-5 card-table">
                        <div className="card-header bg8">
                            <div className="pt-1">
                                Doctors’s List
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row pt-5">
                                <div className="col-8">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Specialist</button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" href="#">Action</a>
                                                <a class="dropdown-item" href="#">Another action</a>
                                                <a class="dropdown-item" href="#">Something else here</a>
                                            </div>
                                        </div>
                                        <input type="text" class="form-control" aria-label="Text input with dropdown button" />
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button"><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="float-right my-2">
                                        <label className="data-label">Active : </label> <Switch defaultChecked onChange={this.onChange} />
                                    </div>

                                </div>
                            </div>
                            <div className="row pt-4 pb-5 align-items-end">
                                {formDataSchema.feilds
                                    .map((feild, key) => {
                                        if (feild.element === 'checkbox') {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col'} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id={feild.text} name={feild.text} value={feild.text} /> <label for={feild.text} className="data-label w-100 custom-control-label">  {feild.text}</label>
                                                    </div>

                                                </div>

                                            )
                                        }
                                    })}
                            </div>
                            <div className="row justify-content-center pb-5">
                                <button className="btn btn-success text-capitalize mr-3">Save</button>
                                <button className="btn btn-success btn-next text-capitalize">cancel</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default User_Doctor_Map;